module.exports = __webpack_public_path__ + "static/media/arrow-left.de454d04.svg";